import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const ClassicCarIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 360 216"
      style={{ enableBackground: 'new 0 0 360 216' }}
    >
      <defs>
        <linearGradient
          id="SVGID_1_"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="216"
          x2="0.7071"
          y2="215.2929"
        >
          <stop offset="0" style={{ stopColor: '#20AC4B' }} />
          <stop offset="0.9831" style={{ stopColor: '#19361A' }} />
        </linearGradient>
      </defs>
      <style type="text/css">
        {`
	        .Arched_x0020_Green{fill: currentColor; stroke: currentColor; stroke-width:0.25; stroke-miterlimit:1;}
	        .st0{fill:currentColor;}
        `}
      </style>
      <g>
        <path
          className="st0"
          d="M213.2,118.4c3.5,0,6.3-2.8,6.3-6.3s-2.8-6.3-6.3-6.3H199c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3H213.2z"
        />
        <path
          className="st0"
          d="M158.5,146.1h-7.4c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3h7.4c3.5,0,6.3-2.8,6.3-6.3S162,146.1,158.5,146.1z"
        />
        <path
          className="st0"
          d="M340.4,103.5c-0.6-0.2-2.6-0.7-5.5-1.2l2.5-9.9c0.8-3.4-1.2-6.8-4.6-7.6c-0.7-0.2-16.3-4.1-33.9-5.6
		c-8.2-0.7-25.7-1-42.1-1.1c-3.1-8.5-10.4-27.6-16.2-34.4c-6-7.1-20.3-8.3-23.1-8.4c-0.1,0-0.2,0-0.3,0c-7.4-0.1-72.9-1-81.3,0
		C120.5,37.2,111.1,46.9,110,48L81.8,77.7l-56.1-0.2c0,0,0,0,0,0c-2.1,0-4,1-5.2,2.7c-1.2,1.7-1.4,3.9-0.7,5.8
		c4.8,12.5,10,26.9,10.7,29.8c0,1-1,3.6-3.1,5.5l-0.4,0.4c-1.9,1.7-5.2,4.7-7.2,8.5c-3,5.7-2.5,11.7,1.6,16.7
		c3.7,4.6,10.4,6.1,17.4,6.1c12.1,0,25.1-4.4,25.3-4.5c3.2-1.3,7.3-3.8,11.4-6.6c-0.3,1.8-0.5,3.7-0.5,5.6
		c0,16.8,13.6,30.4,30.4,30.4c16.8,0,30.4-13.6,30.4-30.4s-13.6-30.4-30.4-30.4c-2,0-4,0.2-5.9,0.6c-0.3,0-0.6,0-0.9,0.1
		c-0.4,0.1-9.2,1.6-18.5,6.2c-2.1,1.1-5.1,3.1-8.6,5.4c-4.2,2.8-9.4,6.3-12.1,7.4c-8.1,3.2-25.7,5-28.2,2.2c-0.9-1.1-1.9-2.4,4.2-8
		l0.5-0.4c3.9-3.6,7.6-9.9,7.1-16c-0.2-2.8-4.1-13.7-8.2-24.6l185.8,0.5c0.6,0,60.5-0.3,77.4,1.1c10.1,0.8,19.7,2.6,25.7,3.8
		l-1.6,6.5c-4,0.6-7.9,1.9-11.1,4.6c-5.1,4.2-4.5,16.2-4.4,17.5c0.5,8,3.4,13.8,8.2,16.8c0.5,0.3,1.1,0.6,1.7,0.9
		c-0.5,0.7-1.1,1.3-1.7,1.8c-1.5,1.2-5.8,2.1-8.3,2.3l-10.2,0.2c-0.9-16-14.2-28.7-30.3-28.7c-1.7,0-3.3,0.1-4.9,0.4
		c-3.5-0.1-14.8,0.4-28.1,10.7c-2.3,1.8-4.2,3.6-6.3,5.6c-2.6,2.5-5.2,5-8.8,7.5c-3.8,2.7-12,4.4-16.5,4.8h-16.1
		c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3h16.4c0.2,0,0.4,0,0.5,0c1.5-0.1,15-1.4,22.9-7.1c4.3-3.1,7.5-6.1,10.2-8.7
		c0.2-0.2,0.5-0.4,0.7-0.7c-0.3,1.7-0.5,3.5-0.5,5.2c0,16.8,13.6,30.4,30.4,30.4c12.9,0,23.9-8.1,28.3-19.4l12.6-0.2
		c0.1,0,0.2,0,0.3,0c1.6-0.1,10.1-0.9,15.3-5c3.6-2.9,5.9-6.9,7.2-9.7c5.5-0.4,10.1-1.7,11-2c2.6-0.8,4.4-3.3,4.4-6v-26.3
		C345,106.8,343.1,104.3,340.4,103.5z M123.1,147.5c0,9.8-8,17.8-17.8,17.8c-9.8,0-17.8-8-17.8-17.8s8-17.8,17.8-17.8
		C115.1,129.8,123.1,137.7,123.1,147.5z M168.8,47.6c0.6,0.1,1.3,0,1.9-0.1c14.3,0.1,30.8,0.2,44.2,0.4v30.2l-76-0.2
		c7.7-12,15.8-24,17.7-25.9C161.8,47.2,168.5,47.6,168.8,47.6z M119.2,56.7C119.2,56.7,119.2,56.6,119.2,56.7
		c0.2-0.2,7.1-7.5,18.3-8.9c1-0.1,3.3-0.2,6.5-0.3c-6,8.1-15.4,22.9-19.9,30c0,0.1-0.1,0.1-0.1,0.2l-24.8-0.1L119.2,56.7z M227.4,78
		V49.9c1.7,0.6,3,1.3,3.6,2c3.2,3.8,8.4,15.9,12.3,26.1C237.1,78,231.5,78,227.4,78z M265.9,165.7c-9.8,0-17.8-8-17.8-17.8
		s8-17.8,17.8-17.8s17.8,8,17.8,17.8S275.7,165.7,265.9,165.7z M332.4,131c-4.1,0.7-8.7,0.8-11.1-0.7c-2.4-1.5-2.8-10.7-1.7-14.4
		c3.1-1.8,8.5-1.8,12.7-1.2V131z"
        />
      </g>
    </svg>
  </StyledSvgIcon>
);
export default ClassicCarIcon;

ClassicCarIcon.propTypes = customIconsPropTypes;
